import { m as motion, useReducedMotion } from "framer-motion";

const roles = [
  { role: "Projektledare", name: "Er fasta kontakt — samma person hela vägen" },
  { role: "Regissör", name: "Sätter tonen, styr inspelningen, äger filmens röst" },
  { role: "Fotograf", name: "Cinematografi, ljus och bildkomposition" },
  { role: "Ljudtekniker", name: "Rena dialoger, atmosfärer och mix" },
  { role: "Klippare", name: "Rytm, dramaturgi, hooks som funkar" },
  { role: "Colorist", name: "Färgen som ger varumärket dess look" },
  { role: "Manusförfattare", name: "Story, vinkel och budskap som landar" },
];

export function CrewRoles() {
  const reduce = useReducedMotion();
  const loop = [...roles, ...roles];

  return (
    <div className="relative overflow-hidden py-6">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-background to-transparent" />
      <motion.div
        className="flex gap-4"
        animate={reduce ? undefined : { x: ["0%", "-50%"] }}
        transition={{ duration: 38, ease: "linear", repeat: Infinity }}
      >
        {loop.map((r, i) => (
          <div
            key={i}
            className="flex w-[280px] shrink-0 flex-col gap-2 rounded-2xl border border-white/10 bg-surface/60 p-5"
          >
            <div className="text-[11px] uppercase tracking-[0.2em] text-mint">{r.role}</div>
            <div className="text-sm leading-relaxed text-foreground/85">{r.name}</div>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
